"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootStoreContext = exports.RootStore = void 0;
var react_1 = require("react");
var modalstore_1 = require("./modalstore");
var authenticationStore_1 = require("./authenticationStore");
var partiesStore_1 = require("./partiesStore");
var questionFieldStore_1 = require("./questionFieldStore");
var questionStore_1 = require("./questionStore");
var RootStore = /** @class */ (function () {
    function RootStore() {
        this.modalStore = new modalstore_1.default(this);
        this.authenticationStore = new authenticationStore_1.default(this);
        this.partiesStore = new partiesStore_1.default(this);
        this.questionFieldStore = new questionFieldStore_1.default(this);
        this.questionStore = new questionStore_1.default(this);
    }
    return RootStore;
}());
exports.RootStore = RootStore;
exports.RootStoreContext = react_1.createContext(new RootStore());
//# sourceMappingURL=rootStore.js.map